// extracted by mini-css-extract-plugin
export var connectionButton = "_aw-1";
export var rightPanel = "_aw-3";
export var stepDescription = "_aw-2";
export var stepIcon = "_aw-0";